<mat-sidenav-container>
	<mat-sidenav #sidenav mode="side" position="end">
		<app-document-viewer [isCloseDisabled]="true" [isCloseEnabled]="true" (close)="toggleSlide()"
			[documentDetails]="selectedDocumentDetails"></app-document-viewer>
	</mat-sidenav>

	<mat-sidenav-content [class.opened]="isOpened">
		<mat-nav-list>
			<ng-container
				*ngIf="containerDetails.documentContainerTypeId != DocumentContainerType.DigitalLogbook; else digitalLogbook_template">
				<ng-container *ngFor="let group of documents">
					<h2 matSubheader>{{ group.groupName != 'null' ? group.groupName : '' }}</h2>
					<mat-list-item (click)="showDocument(doc.documentId, doc.name, doc.name)"
						*ngFor="let doc of group.documents"
						[class.selected]="isOpened && selectedDocumentDetails?.documentId === doc.documentId">
						<div matListAvatar *ngIf="!doc.thumbnailBase64; else imgThumbnail" [class]="getDocIcon(doc)"></div>
						<ng-template #imgThumbnail>
							<img class="image-thumbnail" [src]="getImageThumnail(doc)" />
						</ng-template>
		
						<h3 matLine [title]="doc.name">
							{{getName(doc)}}
						</h3>
						<p matLine>
							<span style="color: lightgray;"> {{doc.type}} </span>
							<span style="text-align: right; float: right; color: lightgray;"> on: {{getDate(doc)}} </span>
						</p>
		
						<div class="document-actions">
							<button mat-icon-button color="primary"
								(click)="downloadFile($event, doc.downloadDocumentId, getDownloadFileName(doc))"
								aria-label="Download document" title="Download">
								<mat-icon>cloud_download</mat-icon>
							</button>
						</div>
					</mat-list-item>
				</ng-container>
			</ng-container>
			<ng-template #digitalLogbook_template>
				<ng-container *ngFor="let group of documents">
					<mat-list-item (click)="showDocument(doc.documentId, doc.name, doc.name)"
						*ngFor="let doc of group.documents"
						[ngClass]="{'selected': isOpened && selectedDocumentDetails?.documentId === doc.documentId, 'digital-log-book-item': true}">
						<div matListAvatar *ngIf="!doc.thumbnailBase64; else imgThumbnail" [class]="getDocIcon(doc)"></div>
						<ng-template #imgThumbnail>
							<img class="image-thumbnail" [src]="getImageThumnail(doc)" />
						</ng-template>
						<h3 class="item__name" matLine [title]="doc.name">
							{{getName(doc)}}
						</h3>
						<p matLine class="item__description">
							<span> {{doc.description}} </span>
						</p>
						<div class="document-actions">
							<button mat-icon-button color="primary"
								(click)="downloadFile($event, doc.downloadDocumentId, getDownloadFileName(doc))"
								aria-label="Download document" title="Download">
								<mat-icon>cloud_download</mat-icon>
							</button>
						</div>
					</mat-list-item>
				</ng-container>
			</ng-template>
		</mat-nav-list>

	</mat-sidenav-content>
</mat-sidenav-container>